import type { SVGProps } from 'react';

const SvgMembersBellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.01339 1.93994C5.80673 1.93994 4.01339 3.73327 4.01339 5.93994V7.86661C4.01339 8.27328 3.84006 8.89327 3.63339 9.23994L2.86673 10.5133C2.39339 11.2999 2.72006 12.1733 3.58673 12.4666C6.46006 13.4266 9.56006 13.4266 12.4334 12.4666C13.2401 12.1999 13.5934 11.2466 13.1534 10.5133L12.3867 9.23994C12.1867 8.89327 12.0134 8.27328 12.0134 7.86661V5.93994C12.0134 3.73994 10.2134 1.93994 8.01339 1.93994Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9.24645 2.13333C9.03979 2.07333 8.82645 2.02667 8.60645 2C7.96645 1.92 7.35312 1.96667 6.77979 2.13333C6.97312 1.64 7.45312 1.29333 8.01312 1.29333C8.57312 1.29333 9.05312 1.64 9.24645 2.13333Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0132 12.7067C10.0132 13.8067 9.11318 14.7067 8.01318 14.7067C7.46652 14.7067 6.95985 14.48 6.59985 14.12C6.23985 13.76 6.01318 13.2533 6.01318 12.7067"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
  </svg>
);
export default SvgMembersBellIcon;
